<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xINWpl/tc-custom/9781467438063.jpg?1744434331205" alt="This image is the cover for the book Who Was Jesus?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who Was Jesus?
      </h1>
      <p class="bookDescription body article font2">
        <p>Did the historical person Jesus really regard himself as the Son of God? What did Jesus actually stand for? And what are we to make of the early Christian conviction that Jesus physically rose from the dead?<br/><br/>In this book N. T. Wright considers these and many other questions raised by three controversial books about Jesus: Barbara Thiering's <i>Jesus the Man</i>, A. N. Wilson's <i>Jesus: A Life</i>, and John Shelby Spong's <i>Born of a Woman</i>. While Wright agrees with those authors that the real, historical Jesus has many surprises in store for institutional Christianity, he also presents solid reasons for discounting their arguments, claiming that they "fail to reach anything like the right answer" as to who Jesus really was.<br/><br/>Written from the standpoint of professional biblical scholarship yet assuming no prior knowledge of the subject, Wright's <i>Who Was Jesus?</i> shows convincingly that much can be gained from a rigorous historical assessment of what the Gospels say about Jesus. This is a book to engage skeptics and believers alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        N. T. Wright
      </h2>
      
      <p class="authorDescription body article">&#160;<BR /><B>N. T. Wright</B>, one of the most highly respected biblical scholars in the world today, is research professor emeritus of New Testament and early Christianity at the University of St. Andrews and senior research fellow at Wycliffe Hall, Oxford. He is the author of over eighty books, including&#160;<I>Simply Christian, Surprised by Hope, Paul and the Faithfulness of God</I>, and&#160;<I>The New Testament in Its World.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a4740df